import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";
import { Sparkles } from "lucide-react";

export const SparkleEyebrow = ({ children, className = "wit-eyebrow text-raspberry" }) => {
  const reduced = usePreferStaticUI();

  return (
    <p className={`flex items-center gap-2 ${className}`}>
      <motion.span
        animate={reduced ? undefined : { rotate: [0, 12, -8, 0], scale: [1, 1.15, 1] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      >
        <Sparkles size={13} className="opacity-80" />
      </motion.span>
      <span>{children}</span>
    </p>
  );
};

export default SparkleEyebrow;
